export const STATUS = {
  LOADING: 'loading',
  IDLE: 'idle',
  SUCCESS: 'success',
  ERROR: 'error',
};
